export default __webpack_public_path__ + "static/media/502.6b1793bc.jpg";